import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { WafService } from '../../service';

export type RulesExportConfig = typeof RulesExportConfig._.Config;

export const RulesExportConfig = IntegrationConfig.make({
  service: WafService,
  name: Integration_Handler_Names_Enum.RulesExport,
  configSchema: z.object({
    zoneId: z.string().min(1),
  }),
});
